import { render, staticRenderFns } from "./Sidenav2.vue?vue&type=template&id=3e0568f0&scoped=true&"
import script from "./Sidenav2.vue?vue&type=script&lang=js&"
export * from "./Sidenav2.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav2.vue?vue&type=style&index=0&id=3e0568f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0568f0",
  null
  
)

export default component.exports